const MoreHorizontalSquare01Icon = /*#__PURE__*/ [
  ["rect", { x: "18", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["rect", { x: "10.5", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["rect", { x: "3", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export { MoreHorizontalSquare01Icon as default };
//# sourceMappingURL=MoreHorizontalSquare01Icon.js.map
